import type { RefObject } from "react";
import { Button } from "@/components/ui/button";

export function InfiniteScrollFooter({
  sentinelRef,
  hasRows,
  isLoadingMore,
  canLoadMore,
  onLoadMore,
}: {
  sentinelRef: RefObject<HTMLDivElement | null>;
  hasRows: boolean;
  isLoadingMore: boolean;
  canLoadMore?: boolean;
  onLoadMore?: () => void;
}) {
  if (!hasRows) return null;
  return (
    <>
      <div ref={sentinelRef} className="h-px w-full" aria-hidden="true" />
      <div className="sticky left-0 flex min-h-12 w-full items-center justify-center px-3 py-2">
        {isLoadingMore ? (
          <span role="status" className="text-sm text-muted-foreground">
            Loading more…
          </span>
        ) : canLoadMore && onLoadMore ? (
          <Button variant="outline" size="compact" onClick={onLoadMore}>
            Load more
          </Button>
        ) : null}
      </div>
    </>
  );
}
